<template>
    <Dialog
        v-model:visible="consultarServiciosDialog"
        :closable="false"
        :modal="true"
        id="overlay_panel"
        style="max-width: 450px"
        class="md:min-w-[400px]"
        :breakpoints="{ '960px': '75vw' }"
        @hide="discard"
    >
        <template #header>
            <div class="font-medium text-gray-600 text-lg mb-2">
                Servicios disponibles
            </div>
        </template>
        <div class="flex flex-col items-center space-y-2 p-2 min-h-[300px]">
            <!-- spinner de carga -->
            <div v-if="loading">
                <div
                    class="w-16 h-16 rounded-full animate-spin border-4 border-solid border-primary-500 border-t-transparent"
                ></div>
            </div>

            <!-- error de servidor -->
            <div
                v-if="isServerError"
                class="flex flex-col justify-center items-center"
            >
                <div class="text-gray-800 text-lg font-semibold">
                    Ha ocurrido un error...
                </div>
                <img
                    src="@assets/images/shared/error_server.svg"
                    class="w-44"
                    alt="server_error"
                />
                <Button @click="$emit('retry')">Intentar nuevamente</Button>
            </div>

            <!-- no se encontraron servicios -->
            <div
                v-if="isNotFoundError"
                class="flex flex-col justify-center items-center"
            >
                <div class="text-gray-800 text-lg font-semibold">
                    No se encontraron servicios...
                </div>
                <img
                    src="@assets/images/shared/not_found_error.svg"
                    class="w-44"
                    alt="no_services_found"
                />
                <Button @click="$emit('retry')">Intentar nuevamente</Button>
            </div>

            <!-- lista de servicios -->
            <div
                class="w-full"
                v-for="servicio in servicios"
                :key="servicio.id"
            >
                <div
                    :class="[
                        'min-h-[6rem] p-4 w-full group flex space-x-5 justify-between items-center border-2 border-gray-400 border-solid rounded-md mb-4 hover:cursor-pointer hover:shadow-md hover:border-primary-400',
                        servicioSeleccionado === servicio.id &&
                            'border-primary-400',
                    ]"
                    v-tooltip.bottom="servicio.sucursal_entrega"
                    @click="servicioSeleccionado = servicio.id"
                >
                    <div class="flex flex-col">
                        <ProveedorLogo :proveedor="servicio.proveedor" />

                        <label
                            :for="'servicio' + servicio.id"
                            class="block ml-2 text-[12px] font-medium text-gray-700 group-hover:cursor-pointer"
                        >
                            {{ servicio.servicio }}
                        </label>
                        <label
                            :for="'servicio' + servicio.id"
                            class="block ml-2 text-[12px] font-medium text-gray-700 group-hover:cursor-pointer"
                        >
                            Tipo de entrega: {{ servicio.tipo_entrega }}
                        </label>
                        <span
                            v-if="servicio.sucursal_entrega"
                            class="text-[12px] text-gray-600"
                        >
                            {{ servicio.sucursal_entrega }}
                        </span>
                    </div>
                    <div class="flex items-center space-x-2">
                        <span
                            class="text-sm group-hover:cursor-pointer text-gray-700"
                            >${{ servicio.precio }}</span
                        >
                        <input
                            :id="'servicio' + servicio.id"
                            type="radio"
                            :value="servicio.id"
                            class="w-4 h-4 flex items-center justify-center border-gray-300 group-hover:cursor-pointer focus:ring-2 focus:ring-primary-300"
                            v-model="servicioSeleccionado"
                        />
                    </div>
                </div>
            </div>
        </div>

        <template #footer>
            <div class="flex justify-end mt-2">
                <Button variant="dismissive" @click="discard">Cancelar</Button>
                <Button
                    :disabled="loading || servicioSeleccionado === null"
                    @click="$emit('crearEnvio', servicioSeleccionado)"
                >
                    Solicitar envio
                </Button>
            </div>
        </template>
    </Dialog>
</template>

<script>
import { Icon } from "@vicons/utils";
import { Plus, Trash, Edit } from "@vicons/fa";
import Button from "@/shared/Button.vue";
import ProveedorLogo from "@/shared/ProveedorLogo.vue";

export default {
    name: "ConsultarServiciosDialog",
    props: {
        consultarServiciosDialog: Boolean,
        loading: Boolean,
        servicios: Array,
        isNotFoundError: Boolean,
        isServerError: Boolean,
    },
    components: {
        Button,
        Icon,
        Plus,
        Trash,
        Edit,
        ProveedorLogo,
    },
    data() {
        return {
            servicioSeleccionado: null,
        };
    },
    methods: {
        discard() {
            this.servicioSeleccionado = null;
            this.$emit("closeDialog");
        },
    },
};
</script>
